import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core'
import { RouterLink } from '@angular/router'

import { ActiveRoute } from '@core/index'
import { IconApp, type IconName } from '@shared/components'

interface ExtraItem {
  label: string
  active_icon: IconName
  inactive_icon: IconName
  route: string
  iconRatio: string
}

@Component({
  selector: 'extras-dropdown',
  imports: [RouterLink, IconApp],
  templateUrl: './extras-dropdown.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExtrasDropdown {
  #activeRoute = inject(ActiveRoute)

  readonly selected = output<void>()

  extraItems: ExtraItem[] = [
    {
      label: 'TABLA DE GOLEADORES',
      active_icon: 'tabla_de_goleadores_active',
      inactive_icon: 'tabla_de_goleadores_inactive',
      route: '/profile/podio',
      iconRatio: '30 / 28'
    },
    {
      label: 'SALA DE PRENSA',
      active_icon: 'sala_de_prensa_active',
      inactive_icon: 'sala_de_prensa_inactive',
      route: '/sala_de_prensa/actualidad',
      iconRatio: '26 / 25'
    },
    {
      label: 'CENTRO DE ENTRENAMIENTO',
      active_icon: 'centro_entrenamiento_active',
      inactive_icon: 'centro_entrenamiento_inactive',
      route: '/centro_de_entrenamiento',
      iconRatio: '1'
    },
    {
      label: 'AYUDA Y REGLAMENTO',
      active_icon: 'ayuda_reglamento_active',
      inactive_icon: 'ayuda_reglamento_inactive',
      route: '/reglamento',
      iconRatio: '1'
    }
  ]

  isActive(route: string): boolean {
    return this.#activeRoute.isActive(route)
  }
}
